import { render, staticRenderFns } from "./RemoveTags.vue?vue&type=template&id=4e77aaf4&"
import script from "./RemoveTags.vue?vue&type=script&lang=js&"
export * from "./RemoveTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports